<template>
  <div>
    <SimpleFieldList
      :disabled="disabled"
      :operators="operators"
      :spr="tenderStatuses"
      :value.sync="mutableValue"/>
  </div>
</template>
<script>
import SimpleFieldList from 'components/automation/conditions/default/simpleFieldList.vue'
/**
 * 7
 */
export default {
  name: 'tenderStatus',
  computed: {
    tenderStatuses() {
      return this.$store.getters.getTenderStatuses.map(i => ({
        key: i.statusCode,
        label: i.title
      }))
        .sort((a,b) => a.label?.localeCompare(b.label))
    },
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleFieldList
  },
  created() {
    this.$store.dispatch('setTenderStatuses')
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
